export default {"src":"/_next/static/media/frame5.acfdf69b.svg","height":109,"width":242,"blurWidth":0,"blurHeight":0};